import React, { useState } from "react";

// Material-UI
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";

import { useSnackbar } from "notistack";
import {
  bankSellerCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import Gap from "../../../components/atoms/Gap";
import {
  Avatar,
  DialogTitle,
  IconButton,
  Paper,
  Typography,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import daftarBank from "./bank.json";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Logo from "../../../assets/icon/LogoMarket";
import {
  FieldValue,
  firefunctions,
} from "../../../components/firebase/FirebaseProvider";
import { useRef } from "react";

function DialogRekening({ open, handleClose, mode, data }) {
  const { profil } = useData();
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const accountName = useRef("");

  const [form, setForm] = useState({
    code_bank: "",
    nama_bank: "",
    nama_rek: "",
    no_rek: "",
  });

  //   console.log(data, form);

  const [error, setError] = useState({
    nama_bank: "",
    no_rek: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setError((error) => ({
      ...error,
      [name]: "",
    }));

    if (name === "bank") {
      setForm((form) => ({
        ...form,
        nama_bank: value?.name,
        code_bank: value?.code,
      }));
    } else {
      setForm((form) => ({
        ...form,
        [name]: value,
      }));
    }
  };

  const validate = async () => {
    let newErrors = { ...error };

    if (!form?.nama_bank) {
      newErrors.nama_bank = "Nama Bank wajib diisi";
    }

    if (!form?.no_rek) {
      newErrors.no_rek = "Nomor Rekening wajib diisi";
    } else if (form?.no_rek.length < 5) {
      newErrors.no_rek = "Nomor Rekening minimal 5 karakter";
    } else {
      const bankValidate = firefunctions.httpsCallable("bankValidate");
      try {
        const validateBank = await bankValidate({
          bank: form?.code_bank,
          no_rek: form?.no_rek,
        });
        console.log(validateBank);
        if (!validateBank?.data?.account_name) {
          newErrors.no_rek = "Nomer Rekening tidak valid";
        } else {
          accountName.current = validateBank?.data?.account_name;
        }
      } catch (e) {
        newErrors.no_rek = "Nomer Rekening tidak valid";
      }
    }
    return newErrors;
  };

  const handleDelete = async () => {
    if (window.confirm(`Apakah Anda Ingin Menghapus Rekening Ini?`)) {
      setIsSubmitting(true);
      try {
        history.push("/akun/rekening");
        await bankSellerCollection.doc(form?.id).delete();
        enqueueSnackbar("Rekening berhasil dihapus!", {
          variant: "success",
        });
        setIsSubmitting(false);
        handleClick();
      } catch (error) {
        setIsSubmitting(false);
        enqueueSnackbar(`Terjadi Kesalahan ${error.message}`, {
          variant: "error",
        });
        handleClick();
      }
    }
  };

  const handleSimpan = async () => {
    setIsSubmitting(true);
    const findErrors = await validate();
    if (Object.values(findErrors).some((err) => err !== "")) {
      setError(findErrors);
      setIsSubmitting(false);
    } else {
      try {
        if (mode === "Edit") {
          await bankSellerCollection.doc(form?.id).set(
            {
              code_bank: form?.code_bank,
              user_id: profil?.id,
              nama_bank: form?.nama_bank,
              nama_rek: accountName?.current,
              no_rek: form?.no_rek,
              updated_at: FieldValue.serverTimestamp(),
            },
            { merge: true }
          );
        } else {
          await bankSellerCollection.add({
            user_id: profil.id,
            nama_bank: form?.nama_bank,
            code_bank: form?.code_bank,
            nama_rek: accountName.current,
            no_rek: form.no_rek,
            created_at: FieldValue.serverTimestamp(),
            updated_at: FieldValue.serverTimestamp(),
          });
        }
        setIsSubmitting(false);
        enqueueSnackbar("Rekening Berhasil Diperbarui", {
          variant: "success",
        });
        handleClick();
      } catch (err) {
        setIsSubmitting(false);
        console.log(err.message);
        enqueueSnackbar("Rekening Gagal Diperbarui", {
          variant: "error",
        });
        handleClick();
      }
    }
  };

  useEffect(() => {
    if (mode === "Edit" && data) {
      setForm({
        ...data,
      });
    }
  }, [mode, data]);

  const handleClick = () => {
    setForm({ code_bank: "", nama_bank: "", nama_rek: "", no_rek: "" });
    setError({ nama_bank: "", no_rek: "" });
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClick}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClick}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>{mode} Rekening</Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 10 }}>
        <div
          style={{
            backgroundColor: "#ECECEC",
            marginTop: -20,
            marginLeft: -10,
            marginRight: -10,
          }}
        >
          <div
            style={{
              padding: "20px 10px",
              margin: 10,
            }}
          >
            <Paper style={{ backgroundColor: "#FF70B4" }}>
              <div
                style={{
                  padding: 10,
                  //   margin: 5,
                  color: "white",
                  fontSize: 15,
                }}
              >
                <p>
                  Pastikan Nomor Rekening dan Nama Pemilik Rekening sesuai
                  dengan buku tabungan
                </p>
                <p>Saya Mengerti</p>
              </div>
            </Paper>
          </div>
        </div>
        <Gap height={15} />
        <Autocomplete
          id="bank"
          name="bank"
          required
          disableClearable
          onChange={(event, value) => {
            handleChange({ target: { name: "bank", value } });
          }}
          disabled={isSubmitting}
          options={daftarBank}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Nama Bank"
              placeholder={
                form?.nama_bank ? form?.nama_bank : "Contoh: Bank BCA"
              }
              InputLabelProps={{ shrink: true }}
              helperText={error?.nama_bank}
              error={error?.nama_bank ? true : false}
              variant="outlined"
            />
          )}
        />{" "}
        {mode === "Edit" ? (
          <>
            <Gap height={20} />
            <TextField
              name="nama_rek"
              label="Nama Rekening"
              fullWidth
              inputProps={{
                maxLength: "20",
              }}
              placeholder="Contoh: Bu Suci"
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={form?.nama_rek}
              helperText={error?.nama_rek}
              error={error?.nama_rek ? true : false}
              disabled
              autoComplete="off"
            />
          </>
        ) : null}
        <Gap height={20} />
        <TextField
          name="no_rek"
          label="Nomor Rekening"
          fullWidth
          inputProps={{
            maxLength: "20",
          }}
          placeholder="Contoh : 18762444572883"
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form?.no_rek}
          helperText={error?.no_rek}
          error={error?.no_rek ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
        />
        <Gap height={15} />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSimpan}
          disabled={isSubmitting}
          style={{ marginBottom: "10px" }}
        >
          Simpan
        </Button>
        {mode === "Edit" ? (
          <Button
            style={{ marginBottom: "10px" }}
            fullWidth
            variant="outlined"
            color="primary"
            onClick={handleDelete}
            disabled={isSubmitting}
          >
            Hapus
          </Button>
        ) : null}
        <div
          onClick={() => history.push("/akun/bantuan")}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            border: "1px solid",
            borderRadius: 8,
          }}
        >
          <Avatar
            style={{
              marginRight: 7.5,
              marginLeft: 7.5,
              height: 60,
              width: 60,
              backgroundColor: "rgb(236, 236, 236)",
            }}
          >
            <Logo />
          </Avatar>
          <div>
            <p
              style={{
                fontSize: 15,
              }}
            >
              Pusat Bantuan
            </p>
            <p
              style={{
                fontSize: 13,
                marginTop: -10,
              }}
            >
              TokoRame siap membantu teman-teman reseller. Jam kerja Senin -
              Sabtu, Jam 08:00 - 17:00 WIB
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default DialogRekening;
